import React  from "react";
import {
    Checkbox,
    SelectChangeEvent,
} from "@mui/material";
import {useTheme} from "../../../contexts/theme";

export interface StyledCheckBoxProps {
    width?: string;
    height?: string;
    checked: boolean;
    onChange: (event: SelectChangeEvent) => void;
    iconSize?: string;
    disabled?: boolean;
    onKeyDown?: (e: React.KeyboardEvent<any>) => void;
}

const StyledCheckBox: React.FC<StyledCheckBoxProps> = ({height, width, onChange, checked, iconSize = "40px", disabled = false, onKeyDown = () => {}}) => {

    const theme = useTheme();

    const activeColor = theme.palette.orange;
    const disabledColor = theme.palette.grey;

    return (
        <Checkbox
            onChange={onChange}
            checked={checked}
            disabled={disabled}
            onKeyDown={onKeyDown}
            sx={{
                height: height ? height : '40px',
                width: width ? width : '40px',
                paddingRight: theme.spacing.md,
                '& .MuiSvgIcon-root': {
                    fontSize: iconSize,
                    fill: disabled ? disabledColor : activeColor + ' !important',

                },
                color: disabled ? disabledColor : theme.palette.lightGrey,
        }}/>
    );
};

export default StyledCheckBox;